<template><div><h1>VUX V2.1.1Rc.6 发布日志</h1>
<h2><a href="/zh-CN/components/popup.html">Popup</a></h2>
<ul><li>[fix] 修复 Safari 上关闭第二个popup导致的问题 #1015 @think2011</li>
</ul>
<h2><a href="/zh-CN/components/toast.html">Toast</a></h2>
<ul><li>[fix] 修复禁止样式被覆盖 #1016 @LaiXuechao</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.1.1Rc.6 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.1.1-rc.6-216.vue?81112866